let children = [
    {
        path: '/Order',
        name: 'Wx_Order',
        component: () => import('@/view/User/Wx_Order/list')
    }
    , {
        path: '/Product',
        name: 'Wx_Product',
        component: () => import('@/view/User/Wx_Product/list')
    }
    , {
        path: '/Users',
        name: 'Wx_User',
        component: () => import('@/view/User/Wx_User/list')
    }
    , {
        path: '/Wx_OrderSub',
        name: 'Wx_OrderSub',
        component: () => import('@/view/User/Wx_OrderSub/list')
    }
    , {
        path: '/IndexMenu',
        name: 'Wx_IndexMenu',
        component: () => import('@/view/User/Wx_IndexMenu/list')
    }
    ,  {
        path: '/Document',
        name: 'Wx_Document',
        component: () => import('@/view/User/Wx_Document/list')
    }
,{
        path: '/UserPhone',
        name: 'Wx_UpdateUser',
        component: () => import('@/view/User/Wx_UpdateUser/list')
    }
,{
        path: '/GroupBuyInfo',
        name: 'Wx_GroupBuyInfo',
        component: () => import('@/view/User/Wx_GroupBuyInfo/list')
    }
,{
        path: '/YH',
        name: 'Wx_YangHu',
        component: () => import('@/view/User/Wx_YangHu/list')
    }
,{
        path: '/LiveInfo',
        name: 'Wx_LiveInfo',
        meta: {},
        component: () => import('@/view/User/Wx_LiveInfo/list')
    }
,{
        path: '/Farm',
        name: '农场信息',
        meta: {},
        component: () => import('@/view/User/Wx_Farm/list')
    }
,{
        path: '/FarmContract',
        name: '农场合同',
        meta: {},
        component: () => import('@/view/User/Wx_FarmContract/list')
    }
,{
        path: '/FarmCost',
        name: '核销',
        meta: {},
        component: () => import('@/view/User/Wx_FarmCost/list')
    }
,{
        path: '/FarmGuidance',
        name: '专家指导',
        meta: {},
        component: () => import('@/view/User/Wx_FarmGuidance/list')
    }
,{
        path: '/FarmInputs',
        name: '投入品',
        meta: {},
        component: () => import('@/view/User/Wx_FarmInputs/list')
    }
,{
        path: '/FarmMedia',
        name: '媒体',
        meta: {},
        component: () => import('@/view/User/Wx_FarmMedia/list')
    }
,{
        path: '/FarmObservation',
        name: '观测记录',
        meta: {},
        component: () => import('@/view/User/Wx_FarmObservation/list')
    }
,{
        path: '/FarmSale',
        name: '产量销售',
        meta: {},
        component: () => import('@/view/User/Wx_FarmSale/list')
    }
,{
        path: '/FarmSignIn',
        name: '上下班签到',
        meta: {},
        component: () => import('@/view/User/Wx_FarmSignIn/list')
    }
,{
        path: '/FarmStock',
        name: '仓库管理',
        meta: {},
        component: () => import('@/view/User/Wx_FarmStock/list')
    }
,{
        path: '/FarmWorkNotice',
        name: '工作管理',
        meta: {},
        component: () => import('@/view/User/Wx_FarmWorkNotice/list')
    }
,{
        path: '/FarmWorkOrder',
        name: '工单管理',
        meta: {},
        component: () => import('@/view/User/Wx_FarmWorkOrder/list')
    }
,{
        path: '/FarmFruit',
        name: 'Wx_FarmFruit',
        meta: {},
        component: () => import('@/view/User/Wx_FarmFruit/list')
    }
,{
        path: '/FarmUser',
        name: '农场人员关系',
        meta: {},
        component: () => import('@/view/User/Wx_FarmRelation/list')
    }
    ,{
        path: '/FarmAssociation',
        name: '协会',
        meta: {},
        component: () => import('@/view/User/Wx_FarmAssociation/list')
    }
,{
        path: '/Video',
        name: 'Wx_Video',
        meta: {},
        component: () => import('@/view/User/Wx_Video/list')
    },{
        path: '/FarmWarehouse',
        name: '仓库管理',
        meta: {},
        component: () => import('@/view/User/Wx_FarmWarehouse/list')
    },{
        path: '/FarmCoreInfo',
        name: '核心基地管理',
        meta: {},
        component: () => import('@/view/User/Wx_FarmCoreInfo/list')
    }
    ,{
        path: '/FarmHonor',
        name: '基地荣誉',
        meta: {},
        component: () => import('@/view/User/Wx_FarmHonor/list')
    }
    ,{
        path: '/FarmProductShow',
        name: '基地产品展示',
        meta: {},
        component: () => import('@/view/User/Wx_FarmProductShow/list')
    },{
        path: '/teamPeople',
        name: '专家团队',
        meta: {type: 'team'},
        component: () => import('@/view/User/Wx_PeopleInfo/list?type=team')
    }
    ,{
        path: '/qdry',
        name: '勤德荣誉',
        meta: {type: 'qdry'},
        component: () => import('@/view/User/Wx_FarmHonor/list?type=qdry')
    }
    ,{
        path: '/bxgxpz',
        name: '百香果新品种',
        meta: {type: 'bxgxpz'},
        component: () => import('@/view/User/Wx_FarmHonor/list?type=bxgxpz')
    }
    ,{
        path: '/sfjd',
        name: '示范基地',
        meta: {type: 'sfjd'},
        component: () => import('@/view/User/Wx_FarmCoreInfo/list?type=sfjd')
    }
    ,{
        path: '/gsgp',
        name: '果实、果品',
        meta: {type: 'gsgp'},
        component: () => import('@/view/User/Wx_FarmHonor/list?type=gsgp')
    }
    ,{
        path: '/lscyh',
        name: '龙胜产业化',
        meta: {type: 'lscyh'},
        component: () => import('@/view/User/Wx_FarmHonor/list?type=lscyh')
    },{
        path: '/zmxsqq',
        name: '种苗销售全球',
        meta: {type: 'zmxsqq'},
        component: () => import('@/view/User/Wx_FarmHonor/list?type=zmxsqq')
    },{
        path: '/syCode',
        name: '溯源码管理',
        meta: {type: 'syCode'},
        component: () => import('@/view/User/Wx_FarmCode/list')
    }
,{
        path: '/ReserveIssue',
        name: '预定',
        meta: {},
        component: () => import('@/view/User/Wx_FarmReserveIssue/list')
    }
,{
        path: '/Wx_FarmReserveRelation',
        name: '预定关联',
        meta: {},
        component: () => import('@/view/User/Wx_FarmReserveRelation/list')
    }
];
export default children


































// WEBPACK FOOTER //
// ./src/router/children.js